/**
 * Personalized Offers Module - With Scroll Dots
 */

(function() {
  'use strict';

  var cartCache = null;
  var cartFetchPromise = null;

  var PersonalizedOffers = {
    init: function() {
      var blocks = document.querySelectorAll('.personalized-offers[data-init="false"]');
      if (blocks.length === 0) return;

      for (var i = 0; i < blocks.length; i++) {
        blocks[i].setAttribute('data-init', 'true');
      }

      this.blocks = blocks;
      this.checkCartAndToggle();
      this.bindEvents();
      this.initCarousels();
    },

    getCart: function() {
      if (cartCache) return Promise.resolve(cartCache);
      if (cartFetchPromise) return cartFetchPromise;

      cartFetchPromise = fetch('/cart.js')
        .then(function(response) { return response.json(); })
        .then(function(cart) {
          cartCache = cart;
          cartFetchPromise = null;
          return cart;
        })
        .catch(function(err) {
          cartFetchPromise = null;
          throw err;
        });

      return cartFetchPromise;
    },

    checkCartAndToggle: function() {
      var self = this;
      
      this.getCart()
        .then(function(cart) {
          var productIdsInCart = {};
          for (var i = 0; i < cart.items.length; i++) {
            productIdsInCart[cart.items[i].product_id] = true;
          }

          for (var j = 0; j < self.blocks.length; j++) {
            var block = self.blocks[j];
            var productId = parseInt(block.getAttribute('data-product-id'));
            var isInCart = productIdsInCart[productId] === true;
            
            self.toggleState(block, isInCart);
          }
        })
        .catch(function(err) {
          console.error('Offers module: cart fetch failed', err);
        });
    },

    toggleState: function(block, isUnlocked) {
      var locked = block.querySelector('.bundle-locked');
      var unlocked = block.querySelector('.bundle-unlocked');
      
      if (isUnlocked) {
        locked.style.display = 'none';
        unlocked.style.display = 'block';
      } else {
        locked.style.display = 'block';
        unlocked.style.display = 'none';
      }
    },

    bindEvents: function() {
      var self = this;
      
      document.addEventListener('click', function(e) {
        if (e.target.classList.contains('bundle-add-btn')) {
          e.preventDefault();
          var variantId = e.target.getAttribute('data-variant-id');
          
          if (!variantId) {
            alert('Please select a variant first');
            return;
          }
          
          self.addToCart(variantId);
        }
      });
    },

    addToCart: function(variantId) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }]
        })
      })
      .then(function(response) { return response.json(); })
      .then(function() {
        window.location.reload();
      })
      .catch(function(err) {
        console.error('Offers module: add to cart failed', err);
        alert('Could not add product. Please try again.');
      });
    },

    initCarousels: function() {
      var carousels = document.querySelectorAll('.offer-products-scroll');
      
      for (var i = 0; i < carousels.length; i++) {
        this.setupCarousel(carousels[i]);
      }
    },

    setupCarousel: function(carousel) {
      var dotsContainer = carousel.parentElement.querySelector('.offer-dots');
      if (!dotsContainer) return;
      
      var dots = dotsContainer.querySelectorAll('.offer-dot');
      var cards = carousel.querySelectorAll('.offer-product-card');
      
      if (dots.length === 0 || cards.length === 0) return;
      
      // Set first dot as active
      dots[0].classList.add('active');
      
      // Update active dot on scroll
      carousel.addEventListener('scroll', function() {
        var scrollLeft = carousel.scrollLeft;
        var cardWidth = cards[0].offsetWidth;
        var gap = 15;
        var currentIndex = Math.round(scrollLeft / (cardWidth + gap));
        
        for (var i = 0; i < dots.length; i++) {
          dots[i].classList.remove('active');
        }
        
        if (dots[currentIndex]) {
          dots[currentIndex].classList.add('active');
        }
      });
      
      // Click dots to scroll
      for (var i = 0; i < dots.length; i++) {
        (function(index) {
          dots[index].addEventListener('click', function() {
            var cardWidth = cards[0].offsetWidth;
            var gap = 15;
            carousel.scrollLeft = index * (cardWidth + gap);
          });
        })(i);
      }
    }
  };

  function initWhenIdle() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(function() {
        PersonalizedOffers.init();
      }, { timeout: 2000 });
    } else {
      setTimeout(function() {
        PersonalizedOffers.init();
      }, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWhenIdle);
  } else {
    initWhenIdle();
  }

})();